<template>
  <OnboardingLinkGeneration
    v-if="generatingLink"
    @close="generatingLink = false"
  />
  <BaseSpinner v-if="!adyenAppStateLoaded" />
  <Dashboard v-else-if="!!adyenAppState.adyenLegalEntityId" />
  <div
    v-else
    :class="[
      $style.base,
      {
        [$style.smallScreen]: $screen === 's',
        [$style.mediumScreen]: $screen === 'm'
      }
    ]"
  >
    <div
      :class="$style.headerContainer"
      ref="onboardingRef"
    >
      <div :class="$style.alertContainer">
        <BaseAlert
          v-if="unleash.isEnabled('SalonizedPay') && (unleash.isEnabled('BlackFridayOffer') || unleash.isEnabled('FreeTerminalOffer')) && !hasTerminals"
          :text="unleash.isEnabled('FreeTerminalOffer') ? $t('register.salonized_pay.landing.info_text_100_offer', { ...brandNamePay(), offerPrice: filters.currency(10000) }) : $t('register.salonized_pay.landing.info_text', brandNamePay())"
          :primaryAction="unleash.isEnabled('FreeTerminalOffer') ? $t('global.actions.accept_offer') : $t('global.actions.claim_offer')"
          @primaryAction="updateInterest"
          v-test="'sp-black-friday-offer'"
        />
      </div>
      <div :class="$style.headerMainContent">
        <div
          v-if="!showOnboarding && !adyenAppState.terminalModel"
          :class="$style.widthContainer"
        >
          <Flex
            direction="column"
            :gap="1.5"
            :align="$screen === 's' ? 'center' : 'start'"
            :justify="$screen === 's' ? 'center' : 'start'"
          >
            <BaseHeading
              size="xl"
              :center="$screen === 's'"
            >
              {{ replacePinapparaat(
                $t('register.salonized_pay.landing.header'),
                company.country
              ) }}
            </BaseHeading>
            <BaseText
              size="l"
              :center="$screen === 's'"
            >
              {{ replacePinapparaat(
                $t('register.salonized_pay.landing.content'),
                company.country
              ) }}
            </BaseText>
            <Flex>
              <BaseButton
                color="inverted"
                :class="$style.watchVideoButton"
                @click="scrollToVideo"
              >
                {{ $t('register.salonized_pay.landing.watch_video') }}
              </BaseButton>
              <BaseButton
                @click="updateInterest"
                v-intercom="'sp-interested'"
                v-test="'sp-interested-button'"
              >
                {{ $t('register.salonized_pay.landing.get_sp', brandNamePay()) }}
              </BaseButton>
            </Flex>
          </Flex>
          <img
            src="/img/salonized-pay/checkout/salonized-pay.svg"
            :class="$style.image"
          >
        </div>

        <div
          v-else
          :class="$style.widthContainer"
          v-test="'sp-onboarding-section-with-tasks'"
        >
          <Flex
            direction="column"
            :class="$style.onboarding"
          >
            <BaseHeading size="xl">
              {{ replacePinapparaat(
                $t('register.salonized_pay.landing.onboarding_header'),
                company.country
              ) }}
            </BaseHeading>
            <BaseText size="l">
              {{ $t('register.salonized_pay.landing.onboarding_subheader', brandNamePay()) }}
              <BaseText
                inline
                @click="scrollToFaq"
              >
                {{ $t('register.salonized_pay.landing.faq_section_link') }}
              </BaseText>
            </BaseText>
          </Flex>
          <div :class="$style.onboardingTasks">
            <OnboardingTasks
              ref="onboardingExpose"
              @generateLink="generatingLink = true"
              :disableSalonizers="disableSalonizers"
            />
          </div>
        </div>
      </div>
      <div :class="$style.firstWave" />
    </div>

    <div :class="$style.pageContent">
      <div :class="$style.videoContainer">
        <div :class="$style.cardWrapper">
          <BaseCard
            gray
            fullHeight
            fullWidth
          >
            <Flex direction="column">
              <Flex
                direction="column"
                :gap="0.5"
              >
                <BaseHeading>
                  {{ $t('register.salonized_pay.landing.in_store_terminals.heading') }}
                </BaseHeading>
                <BaseText>
                  {{ $t('register.salonized_pay.landing.in_store_terminals.description') }}
                </BaseText>
              </Flex>
              <Flex
                direction="column"
                :gap="0.25"
              >
                <BaseText>
                  •
                  {{ $t('register.salonized_pay.landing.in_store_terminals.bullet_1', brandName()) }}
                </BaseText>
                <BaseText>
                  •
                  {{ $t('register.salonized_pay.landing.in_store_terminals.bullet_2') }}
                </BaseText>
                <BaseText>
                  •
                  {{ $t('register.salonized_pay.landing.in_store_terminals.bullet_3') }}
                </BaseText>
              </Flex>
              <Flex
                direction="column"
                :gap="0.5"
              >
                <BaseText @click="scrollToTerminals">
                  {{ $t('register.salonized_pay.landing.in_store_terminals.go_to_terminals') }}
                </BaseText>
                <div :class="$style.cardImgContainer">
                  <img
                    src="/img/salonized-pay/checkout/successful-payment.svg"
                    :class="$style.cardImg"
                    alt="In-store Terminals"
                    style="margin-top: 2rem;"
                  >
                </div>
              </Flex>
            </Flex>
          </BaseCard>
        </div>
        <div :class="$style.cardWrapper">
          <BaseCard
            gray
            fullHeight
            fullWidth
          >
            <Flex direction="column">
              <Flex
                direction="column"
                :gap="0.5"
              >
                <BaseHeading>
                  {{ $t('register.salonized_pay.landing.online_prepayments.heading') }}
                  {{ !unleash.isEnabled('SalonizedPayOnline') ? '*' : '' }}
                </BaseHeading>
                <BaseText>
                  {{ $t('register.salonized_pay.landing.online_prepayments.description') }}
                </BaseText>
              </Flex>
              <Flex
                direction="column"
                :gap="0.25"
              >
                <BaseText>
                  •
                  {{ $t('register.salonized_pay.landing.online_prepayments.bullet_1') }}
                </BaseText>
                <BaseText>
                  •
                  {{ $t('register.salonized_pay.landing.online_prepayments.bullet_2') }}
                </BaseText>
                <BaseText>
                  •
                  {{ $t('register.salonized_pay.landing.online_prepayments.bullet_3') }}
                </BaseText>
              </Flex>
              <div :class="$style.cardImgContainer">
                <img
                  src="/img/salonized-pay/checkout/online-payments.png"
                  :class="$style.cardImg"
                  alt="Online Prepayments"
                  style="margin-top: 1rem;"
                >
              </div>
              <BaseText
                v-if="!unleash.isEnabled('SalonizedPayOnline')"
                italic
                size="s"
                color="secondary"
              >
                *
                {{ $t('register.salonized_pay.landing.online_prepayments.online_payments_disclamer', brandNamePay()) }}
              </BaseText>
            </Flex>
          </BaseCard>
        </div>
      </div>
    </div>
    <div :class="$style.pricing">
      <Testimonial />
      <Pricing />
    </div>
    <PaymentMethods />
    <div :class="$style.stepsContainer">
      <div :class="$style.secondWave" />
      <Steps @getStarted="getStarted" />
      <div
        ref="terminalsComparisonRef"
        :class="$style.terminalsComparisonWrapper"
      >
        <TerminalsComparison @select="selectTerminal" />
      </div>
      <InformationCard
        v-if="vimeoLink"
        :heading="
          $t('register.salonized_pay.landing.video_section.how_it_works')
        "
        :title="$t('register.salonized_pay.landing.video_section.heading_1', brandName())"
        :description="
          $t('register.salonized_pay.landing.video_section.description_1')
        "
        padding
        :class="{ [$style.largeScreenOffset]: $screen === 'l' }"
      >
        <div
          ref="videoRef"
          :class="$style.videoWrap"
        >
          <div :class="$style.videoWrapInner">
            <iframe
              :class="$style.video"
              :src="vimeoLink"
              frameborder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowfullscreen
            />
          </div>
        </div>
      </InformationCard>
      <Support />
      <div
        ref="faqRef"
        :class="$style.faqWrap"
      >
        <BaseHeading center>
          {{ $t('register.salonized_pay.landing.faq') }}
        </BaseHeading>
        <div :class="$style.faq">
          <FAQ />
        </div>
      </div>
    </div>
  </div>
  <TerminalsModal
    v-if="showTerminalsModal"
    :terminalId="selectedTerminal"
    @close="showTerminalsModal = false"
    @save="saveTerminal"
  />
  <OnboardingDetails
    v-if="showOnboardingModal"
    @close="showOnboardingModal = false"
    @refetch="refetchAdyenAppState"
  />
</template>

<script
  lang="ts"
  setup
>
import { storeToRefs } from 'pinia';
import { computed, ref } from 'vue';
import config from '@/config';
import filters from '@/filters.js';
import { brandName, brandNamePay } from '@/helpers/brand-name';
import { replacePinapparaat } from '@/helpers/formatting';
import { useAdyenStore } from '@/stores/adyen';
import { useCompanyStore } from '@/stores/company';
import { useUserStore } from '@/stores/user';
import unleash from '@/unleash';
import Dashboard from './dashboard/index.vue';
import FAQ from './FAQ.vue';
import { vimeoId } from './helpers';
import InformationCard from './InformationCard.vue';
import OnboardingTasks from './onboarding/index.vue';
import OnboardingDetails from './onboarding/OnboardingDetails.vue';
import OnboardingLinkGeneration from './onboarding/OnboardingLinkGeneration.vue';
import PaymentMethods from './PaymentMethods.vue';
import Pricing from './Pricing.vue';
import Steps from './Steps.vue';
import Support from './Support.vue';
import TerminalsComparison from './TerminalsComparison.vue';
import TerminalsModal from './TerminalsModal.vue';
import Testimonial from './Testimonial.vue';

const { company, updateCompany } = useCompanyStore();
const { adyenAppState } = useAdyenStore();
const showOnboarding = ref(false);
const showOnboardingModal = ref(false);
const videoRef = ref();
const faqRef = ref();
const showTerminalsModal = ref(false);
const selectedTerminal = ref<number | undefined>();
const onboardingRef = ref();
const generatingLink = ref(false);
const { refetchAdyenAppState } = useAdyenStore();
const { adyenAppStateLoaded, hasTerminals } = storeToRefs(useAdyenStore());
const { user, hasFeatureFlag } = useUserStore();
const terminalsComparisonRef = ref();

const disableSalonizers = computed(() =>
  config.isProduction || config.isTest || config.isStaging
    ? Boolean(user?.salonizedAdmin || user?.impersonated)
    : false,
);

watch(
  () => adyenAppState.terminalModel,
  (newVal) => {
    if (newVal) {
      showOnboarding.value = true;
    }
  },
);

const saveTerminal = () => {
  showOnboarding.value = true;
  scrollToTop();
};

const vimeoLink = computed(() =>
  vimeoId.value
    ? `https://player.vimeo.com/video/${vimeoId.value}?h=5fe6fd26f8&title=0&byline=0&portrait=0`
    : null,
);

const scrollToVideo = () => {
  videoRef.value.scrollIntoView({ block: 'start', behavior: 'smooth' });
};

const scrollToFaq = () => {
  faqRef.value.scrollIntoView({ block: 'start', behavior: 'smooth' });
};

const scrollToTop = () => {
  onboardingRef.value.scrollIntoView({ block: 'start', behavior: 'smooth' });
};

const updateInterest = () => {
  updateCompany({
    settings: {
      general: {
        salonizedPayInterest: true,
      },
    },
  }).then(() => {
    showOnboarding.value = true;
    if (!selectedTerminal.value && hasFeatureFlag('admin-salonized-pay')) {
      showOnboardingModal.value = true;
    }
  });
};

const selectTerminal = (terminalId: number) => {
  selectedTerminal.value = terminalId;
  updateInterest();
  showTerminalsModal.value = true;
};

const getStarted = () => {
  updateInterest();
  scrollToTop();
};

const scrollToTerminals = () => {
  terminalsComparisonRef.value?.scrollIntoView({
    block: 'start',
    behavior: 'smooth',
  });
};
</script>

<style
  lang="scss"
  module
>
.base {
  height: 100%;
  width: 100%;
  background-color: var(--color-bg);
}

.watchVideoButton {
  margin-right: $spacing * 0.5;
}

.largeScreenOffset {
  margin-right: $spacing;
}

.widthContainer {
  max-width: 950px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .base:not(.smallScreen):not(.mediumScreen) & {
    height: 80vh;
  }

  .smallScreen & {
    flex-direction: column;
    align-items: center;
  }

  .mediumScreen & {
    flex-direction: column;
    align-items: center;
    height: 100%;
    padding-bottom: $spacing * 4;
  }
}

.videoContainer {
  max-width: 950px;
  width: 100%;
  display: flex;
  gap: $spacing;
  align-items: stretch;
  padding: $spacing;

  .smallScreen & {
    flex-direction: column;
    align-items: center;
    margin-bottom: $spacing * 2;
    gap: $spacing * 2;
  }

  .mediumScreen & {
    flex-direction: column;
    align-items: center;
    margin-bottom: $spacing * 5;
    height: 100%;
    gap: $spacing * 2;
  }
}

.headerContainer {
  display: flex;
  flex-direction: column;
  gap: $spacing;
  width: 100%;
  position: relative;

  &:not(.smallScreen) {
    height: 100%;
  }

  .mediumScreen & {
    height: 100%;
  }

  background-size: 100% 100%;
  background-position:
    0px 0px,
    0px 0px,
    0px 0px;

  @include theme('light') {
    background-image: linear-gradient(0deg, #dcdcf9d1 1%, #ffffff00 28%),
      radial-gradient(75% 75% at 88% -21%, #03cfa569 1%, #ffffff00 62%),
      radial-gradient(75% 75% at 50% 50%, #ffffffff 0%, #ffffffff 99%);
  }

  @include theme('dark') {
    background-image: 
      radial-gradient(75% 75% at 88% -21%, #03cfa569 1%, #ffffff00 62%),
      radial-gradient(75% 75% at 50% 50%, #00000000 0%, #00000000 99%);
  }
}

.headerMainContent {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: $spacing;
  padding: $spacing;
}

.interested {
  display: flex;
}

.informationContainer {
  .smallScreen & {
    margin-top: $spacing;
    width: 100%;
  }

  .mediumScreen & {
    display: flex;
    gap: $spacing;

    width: 100%;
  }
}

.videoWrap {
  width: 570px;
  max-width: 570px;

  scroll-margin-top: $spacing * 5;
}

.videoWrapInner {
  position: relative;
  width: 100%;
  padding-bottom: 56.4%;
}

.video {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.heading {
  width: 550px;
  max-width: 100%;

  &.onboarding {
    width: 800px;
  }

  .smallScreen & {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: $spacing;
  }

  .mediumScreen & {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: $spacing * 5;
  }
}

.alertContainer {
  padding: $spacing;
}

.image {
  max-width: 532px;
  max-height: 410px;
  width: 100%;
  height: auto;
  margin-left: $spacing * 2;

  .smallScreen & {
    margin-top: $spacing * 4;
    margin-left: 0px;
    max-height: 230px;
  }

  .mediumScreen & {
    margin-top: $spacing * 4;
    margin-left: 0px;
    padding-bottom: 100px;
  }
}

.firstWave {
  position: absolute;
  bottom: 0;
  background-image: url('/img/salonized-pay/rectangle2.svg');
  width: 100%;
  height: 100px;
  background-size: cover;
  background-repeat: no-repeat;

  @include theme('dark') {
    display: none;
  }
}

.pageContent {
  background-color: var(--color-bg);
  display: flex;
  justify-content: space-around;
  width: 100%;

  .base:not(.smallScreen):not(.mediumScreen) & {
    padding-top: $spacing * 3;
  }
  
  .base.smallScreen &, .base.mediumScreen & {
    padding-top: $spacing * 2;
  }
}

.cardImgContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.cardImg {
  max-height: 180px;
}

.pricing {
  background-color: var(--color-bg);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 100px 0px 100px 0px;
  text-align: start;

  .smallScreen &,
  .mediumScreen & {
    padding: 0px $spacing $spacing * 2;
    text-align: center;
  }
}

.stepsContainer {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: $spacing * 3;
}

.secondWave {
  position: absolute;
  top: 30px;
  background-image: url('/img/salonized-pay/rectangle2.svg');
  transform: scaleY(-1);
  width: 100%;
  height: 100px;
  background-size: cover;
  background-repeat: no-repeat;

  @include theme('dark') {
    display: none;
  }
}

.faqWrap {
  width: 100%;
  padding-top: $spacing * 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: $spacing * 2;
}

.faq {
  width: 100%;
  display: flex;
  justify-content: center;
}

.onboardingTasks {
  width: 100%;
  margin-left: $spacing * 4;

  .smallScreen & {
    margin-left: 0px;
  }

  .mediumScreen & {
    margin: $spacing * 2;
    margin-bottom: $spacing * 4;
  }
}

.cardWrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.terminalsComparisonWrapper {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
